import { useState } from "react";
import { Loader2, MessageSquareText } from "lucide-react";
import { http, errorText } from "@/lib/adminApi";

export const QuestionsPanel = ({ o, onUpdate }) => {
  const [open, setOpen] = useState(false);
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");
  const questions = Array.isArray(o.questions) ? o.questions : [];

  const send = async () => {
    setBusy(true);
    setMsg("");
    try {
      const lines = text.split("\n").map((l) => l.trim()).filter(Boolean);
      const { data } = await http.post(`/admin/orders/${o.id}/questions`, { questions: lines });
      onUpdate(o.id, { questions: Array.isArray(data?.questions) ? data.questions : questions });
      setText("");
      setOpen(false);
    } catch (err) { setMsg(errorText(err)); }
    setBusy(false);
  };

  return (
    <div className="mt-5 border-t border-white/10 pt-4" data-testid={`admin-questions-panel-${o.id}`}>
      {questions.length > 0 && (
        <ul className="mb-4 space-y-3">
          {questions.map((q) => (
            <li key={q.id} className="rounded-xl bg-[var(--ink)] p-3 text-sm" data-testid={`admin-question-${q.id}`}>
              <p className="text-slate-300">Q: {q.text}</p>
              {q.answer
                ? <p className="mt-1 whitespace-pre-wrap text-[var(--teal)]">A: {q.answer}</p>
                : <p className="mt-1 italic text-slate-400">Waiting for answer</p>}
            </li>
          ))}
        </ul>
      )}
      {o.reminder_sent_at && questions.some((q) => !q.answer) && (
        <p className="mb-3 text-xs text-slate-400" data-testid={`admin-reminder-sent-${o.id}`}>Reminder emailed {new Date(o.reminder_sent_at).toLocaleString()}</p>
      )}
      {open ? (
        <div className="space-y-3">
          <textarea rows={4} value={text} onChange={(e) => setText(e.target.value)} data-testid={`admin-questions-input-${o.id}`}
            placeholder={"One question per line, e.g.\nHow many complaints did you handle per week?\nWhat was the response time before and after?"}
            className="w-full rounded-xl border border-white/15 bg-[var(--ink)] px-4 py-3 text-sm text-white placeholder:text-slate-500 focus:border-[var(--teal)] focus:outline-none" />
          <div className="flex gap-3">
            <button onClick={send} disabled={busy || !text.trim()} data-testid={`admin-questions-send-${o.id}`}
              className="inline-flex items-center gap-2 rounded-full bg-[var(--teal)] px-4 py-2 text-sm font-semibold text-[var(--ink)] disabled:opacity-40">
              {busy && <Loader2 className="h-4 w-4 animate-spin" />} Email questions
            </button>
            <button onClick={() => setOpen(false)} className="text-sm text-slate-300 hover:text-white">Cancel</button>
          </div>
        </div>
      ) : (
        <button onClick={() => setOpen(true)} data-testid={`admin-questions-open-${o.id}`}
          className="inline-flex items-center gap-2 rounded-full border border-white/20 px-4 py-2 text-sm text-slate-200 hover:border-[var(--teal)]">
          <MessageSquareText className="h-4 w-4" /> {questions.length ? "Ask more questions" : "Ask about their numbers"}
        </button>
      )}
      {msg && <p className="mt-2 text-sm text-[var(--amber)]" role="alert">{msg}</p>}
    </div>
  );
};
